import { render } from "./VarticalStyle.vue?vue&type=template&id=33c2d960"
import script from "./VarticalStyle.vue?vue&type=script&lang=ts"
export * from "./VarticalStyle.vue?vue&type=script&lang=ts"
script.render = render

export default script